$(document).ready(function(){

//     var numbersString = $(".hidden-collection").text();
// var numbersArray = numbersString.split(',');
//     for (i = 0; i < numbersArray.length; ++i) {
//        $(".single-collection").each(function(){
//       if($(this).attr("data-collection-name") == numbersArray[i]){
//         $(this).addClass("asas");
//       }
//        });
//     }
  


  
  if ($(window).width() < 992) {
 $('.parent-slider-collection').slick({
  infinite: false,
   dots:true,
  slidesToShow: 2,
  slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 577,
      settings: {
        slidesToShow: 1
        
      }
    }
      ]
});
  }
   var numitemstotal =$(".collection-list-section .single-collection").length;
      $(".collection-count").text(numitemstotal);
  
  $(".filter-collection li").click(function(){
    if($(this).parent().hasClass("last-find_tabs")){
      $(".collection-list-section").css("height",$(this).parents(".find-page-collection").find(".collection-list-section").height()+"px");
      $(".collection-list-section").css("opacity","0.06");
      $('html, body').animate({scrollTop: $('.find-page-collection').offset().top}, 1500);
      setTimeout(function(){
        $(".collection-list-section").css("opacity","1");
        $(".collection-list-section").css("height","auto");
      },1800);
    }
      // $('html, body').animate({scrollTop: $('.find-page-collection').offset().top}, 1500);
     $(".filter-collection li").not($(this)).removeClass("active");
    $(this).addClass("active");
    var attrmatch = $('.filter-collection li.active').index();
$(".filter-collection").each(function(){
  
    
$(this).find("li").eq(attrmatch).addClass("active");
})    
    // $(this).toggleClass("active");
    // if(!$(this).hasClass("active")){
    //   $(".single-collection").each(function(){
    //      $(this).addClass("show-collection");
    //       $(this).removeClass("hide-collection");
    //   });
    //   $(".collection-count").text(numitemstotal);
    // }
    // else{
      
    if($(this).attr("filter-rex") == "/^[a-d]/i"){
    var filter = /^[a-d]/i;  
    }
    else if($(this).attr("filter-rex") == "/^[e-k]/i"){
      var filter = /^[e-k]/i;  
    }
    else if($(this).attr("filter-rex") =="/^[l-o]/i"){
      var filter = /^[l-o]/i;
    }
    else if($(this).attr("filter-rex") =="/^[p-u]/i"){
       var filter = /^[p-u]/i;
    }
    else{
    var filter =/^[v-z]/i ;  
    }
    
   
   $(".single-collection").each(function(){
     
      var textname = $(this).find(".cm_colec_title span").text();
      
      
        if (filter.test(textname)) {
          $(this).addClass("show-collection");
          $(this).removeClass("hide-collection");
          if($(this).css('display') == 'none'){
          $(this).removeClass("show-collection");
          $(this).addClass("hide-collection");
    
}
          else{
           $(this).addClass("show-collection");
          $(this).removeClass("hide-collection");
          }
        }
     else{
       $(this).addClass("hide-collection");
       $(this).removeClass("show-collection");
     if($(this).css('display') == 'none'){
          $(this).removeClass("show-collection");
          $(this).addClass("hide-collection");
    
}
          else{
           $(this).addClass("show-collection");
          $(this).removeClass("hide-collection");
          }
     }
      
    })
      var numitems =$(".show-collection").length;
      $(".collection-count").text(numitems);
    // }
  });
  $(".filter-collection li").first().click();

$(".best_sellers_tabs").append($(".best_sellers_tabs li").remove().sort(function(a, b) {
    var at = $(a).text(), bt = $(b).text();
    return (at > bt)?1:((at < bt)?-1:0);
}));
  
if($('.template-page').length > 0){
  
  function getcollectionlink(collink) {
    $.get(collink, function(html) {      
      var c_html = $(html).find(".collection-grid").html(),
        c_count = $(html).find(".collection-filter__item--count").text(),
        c_pagination = $(html).find(".pagination").html(),
        c_sortby =  $(html).find('.collection-filter select').val();        
      $('.find-collection-grid').html(c_html);
      $('.find-collection-content .collection-filter__item--count').html(c_count);
      $('.find-collection-grid .grid-product').removeClass('medium-up--one-third').addClass('medium-up--one-quarter');

      $('.find-collection-content .collection-filter select option[value="'+c_sortby+'"]').attr('selected','selected');
      
      
      if(c_pagination == undefined){
        $('.find-collection-content .pagination').html('');
      }else{
         $('.find-collection-content .pagination').html(c_pagination);
      }
      $('.find-collection-content .pagination a').each(function () {
        $(this).attr('data-href',$(this).attr('href'));
        $(this).removeAttr('href');
      });      
    });
  }
   $(document).on("click",".best_sellers_tabs li" ,function(){   

   
     if($(this).hasClass('active')){
  debugger;
      let currentUrl = location.href;
      let url = new URL(currentUrl);
      url.searchParams.delete('filter.p.product_type');
      let newUrl = url.href; 
      window.history.pushState({ path: newUrl }, '', newUrl);
       
       if(location.search.includes('sort_by')){
         var collink = location.origin + $(this).attr('filter-remove') + location.search;
       }else{
           var collink = location.origin + $(this).attr('filter-remove');
       }

        var clean_uri = location.protocol + "//" + location.host + location.pathname + location.search.replace($(this).attr('filter-handle'),'');
        window.history.replaceState({}, document.title, clean_uri);

        $(".best_sellers_tabs li").removeClass("active");    
       $(this).removeClass("active"); 
     }
     else{
         debugger;
       
     $(".best_sellers_tabs li").removeClass("active");     
     $(this).addClass("active"); 

     if(location.search.includes('sort_by')){
     var collink = location.origin + $(this).attr('filter-rex')+location.search.replace('?','&');
     }else{
       var collink = location.origin + $(this).attr('filter-rex');
     }

        let currentUrl = location.href;
        let url = new URL(currentUrl);
        url.searchParams.set("filter.p.product_type", $(this).attr('title')); // setting your param
        let newUrl = url.href; 
        window.history.pushState({ path: newUrl }, '', newUrl);
     }
     
     
     
     
     getcollectionlink(collink);    
     
  });

   $(document).on("click",".find-collection-content .pagination a" ,function(){ 
     var collink = $(this).attr('data-href'); 
     if(collink != undefined){
        getcollectionlink(collink); 
     }
     $("html, body").animate({ scrollTop: $('#CollectionAjaxContent').offset().top }, "slow");     
  });
  
  if(location.search != ''){  
    var collink =   $('.find-collection-url').val()+location.search;    
    getcollectionlink(collink); 

    var taba = location.search.split('product_type=')[1].split('&')[0];
    $(".best_sellers_tabs li").removeClass("active");    
    $('.best_sellers_tabs li[title="'+taba+'"]').addClass("active"); 
  }
}
// 20-10
$(document).on("click", ".find-collections-content .last-find_tabs li", function () {

});



})